"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.history = void 0;
var history_1 = require("history");
exports.history = (0, history_1.createBrowserHistory)();
